import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

// Send httpOnly auth cookies with every request and strip any stale
// localStorage-era Authorization headers so cookie-based auth is authoritative.
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  const headers = config.headers;
  if (headers) {
    const auth = typeof headers.get === "function" ? headers.get("Authorization") : headers.Authorization;
    if (auth === "Bearer null" || auth === "Bearer undefined" || auth === "Bearer ") {
      if (typeof headers.delete === "function") headers.delete("Authorization");
      else delete headers.Authorization;
    }
  }
  return config;
});

import StreakQuiz from "@/pages/StreakQuiz";
import ChallengePage from "@/pages/ChallengePage";
import SuccessPage from "@/pages/SuccessPage";
import PricingPage from "@/pages/PricingPage";
import DashboardPage from "@/pages/DashboardPage";
import MyChallengesPage from "@/pages/MyChallengesPage";
import AuthVerifyPage from "@/pages/AuthVerifyPage";
import FounderDashboard from "@/pages/FounderDashboard";
import QADebugPanel from "@/components/QADebugPanel";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StreakQuiz />} />
          <Route path="/challenge/:challengeId" element={<ChallengePage />} />
          <Route path="/dashboard/:token" element={<DashboardPage />} />
          <Route path="/my-challenges" element={<MyChallengesPage />} />
          <Route path="/auth/verify" element={<AuthVerifyPage />} />
          <Route path="/founder" element={<FounderDashboard />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          {/* Redirect deprecated /advanced-math route to home */}
          <Route path="/advanced-math" element={<Navigate to="/" replace />} />
          {/* Catch-all redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
        <QADebugPanel />
      </BrowserRouter>
    </div>
  );
}

export default App;
